<div class="login">
  <div class="container-fluid h-100 no-gutters">
    <div class="row h-100">
      <div class="col-12 col-md-5 p-5">
        <img src="img/combined-shape.svg" />
        <div class="h1-eq">Customer Value Challenge</div>
        <div class="h3-eq">
          With your team manage your business and make the right decisions...
        </div>
        <div *ngIf="errorMessage" class="error">{{ errorMessage }}</div>
        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
          <input
            type="text"
            formControlName="username"
            class="form-control"
            [ngClass]="{ 'is-invalid': submitted && f.username.errors }"
            placeholder="User name"
          />
          <div *ngIf="submitted && f.username.errors" class="invalid-feedback">
            <div *ngIf="f.username.errors.required">Username is required</div>
          </div>
          <input
            type="password"
            formControlName="password"
            class="form-control"
            [ngClass]="{ 'is-invalid': submitted && f.password.errors }"
            placeholder="Password"
          />
          <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
            <div *ngIf="f.password.errors.required">Password is required</div>
          </div>

          <input
            class="btn text-uppercase"
            type="submit"
            value="Log In"
            [disabled]="loading"
          />
        </form>
        <div id="powered">
          <a href="http://megalearning.com/" target="_blank">
            <span id="powered-text">POWERED BY&nbsp;&nbsp;&nbsp;</span>
            <img src="img/mega-light.svg" alt="MEGA Learning" />
          </a>
        </div>
      </div>
      <div class="col-md-7 right-col d-none d-md-block">&nbsp;</div>
    </div>
  </div>
</div>
